import { render, staticRenderFns } from "./Magnum.vue?vue&type=template&id=7dc4e496&"
import script from "./Magnum.vue?vue&type=script&lang=js&"
export * from "./Magnum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports